if (!customElements.get('search-suggestions')) {
  /* Aranacak alanlar — variants.sku = stok kodu, variants.barcode = barkod */
  const SEARCH_FIELDS = 'title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag';

  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.searchInput = this.closest('form').querySelector('input[name="q"]');
      this.searchInput.addEventListener('keyup', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort('Existing request not needed');
          this.searchSuggestionsAbortController = null;
        }

        this.innerHTML = '';
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort('Existing request not needed');
      }
      this.searchSuggestionsAbortController = new AbortController();

      /* ── DEĞİŞEN KISIM ────────────────────────────────────────────────
         Eskiden sadece q + section_id gönderiliyordu. Parametre yoksa
         Shopify varsayılan olarak sadece product döndürür ve SADECE
         title/product_type/variants.title/vendor içinde arar → stok kodu
         hiçbir zaman eşleşmez.
         Aşağıda hem istenen kaynak tipleri hem de variants.sku alanı
         açıkça belirtiliyor.
      ────────────────────────────────────────────────────────────────── */
      const params = new URLSearchParams();
      params.set('q', terms);
      params.set('section_id', 'search-suggestions');
      params.set('resources[type]', 'product,query,collection');
      params.set('resources[limit]', '6');
      params.set('resources[options][fields]', SEARCH_FIELDS);
      params.set('resources[options][unavailable_products]', 'last');

      fetch(`${theme.routes.predictiveSearch}?${params.toString()}`, {
        signal: this.searchSuggestionsAbortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');

          this.innerHTML = '';
          if (results && results.firstElementChild) {
            this.insertAdjacentElement('beforeend', results.firstElementChild);
          }
        })
        .catch((error) => {
          console.warn(error); // eslint-disable-line no-console
          if (error.code === 20) {
            return; // aborted
          }
          throw error;
        });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}